$( document ).ready(function()
{

    var civil_choice = 'matching';

    function monitorSolicitorFinderForm()
    {
      $('#solicitor_finder_form_new input, #solicitor_finder_form_new select').change(function(e)
      {
          var test1 = $('input[type=radio][name=category_parent]').is(':checked');
          var test2 = ($('#userCurrentCity').text() != "" && $('#userCurrentCity').text() != null);
          var test3 = $('input[type=radio][name=results_type]').is(':checked');
          if (test1 && test2 && test3)
          {
            $('#submitToNext').prop("disabled", false);
            $('.what-you-need').addClass("hide");
          }
          else
          {
            $('#submitToNext').prop("disabled", true);
            $('.what-you-need').removeClass("hide");
          }
      });
    }

    $(".new_form_category_parent").change(function()
    {
        var choice = $( "input[type=radio][name=category_parent]:checked" ).val();

        if (choice == "civil")
        {
            $("#solicitor-finder-child-group").removeClass("hide");
            $("#solicitor-finder-child-group-2").removeClass("hide");
            if (civil_choice == 'matching')
            {
              civil_choice = 'Civil';
            }
        }
        else
        {
            $("#solicitor-finder-child-group").addClass("hide");
            $("#solicitor-finder-child-group-2").addClass("hide");
            civil_choice = 'matching';
        }
        updateCivilChoice();
    });

    $(".civil-children-list").change(function()
    {
        civil_choice = $( ".civil-children-list option:selected" ).text();
        updateCivilChoice();
    });


    function updateCivilChoice()
    {
      $('#currentCivilChoice').html(civil_choice);
      $('#currentCivilChoice2').html(civil_choice);
    }


    const $selectCustomLocation = $("#select-customlocation");

    $selectCustomLocation.on("click tap touchstart",  (e) => {
        e.preventDefault();
        manualLocationNew();
    });



    function setCookie(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    function manualLocationNew()
    {
        $selectCustomLocation.addClass("disabled");
        const useAddress = $("#search_address_new").val();

        const requirements = {state: "scotland", country_code: "gb"}

        const callback = (data) => {
            const address = data ? data.address : null;
            const customLat = data ? parseFloat(data.lat) : null;
            const customLng = data ? parseFloat(data.lon) : null;

            let finalString = "";

            if (address && customLat && customLng)
            {
                localStorage.removeItem('storedMapPage')

                let city = null;
                if(address.city){
                    city = address.city;
                } else if(address.town){
                    city = address.town;
                } else if(address.village){
                    city = address.village;
                } else if(address.county){
                    city = address.county;
                }
                let finalAddress = "";
                if(data.display_name){
                    finalAddress = data.display_name;
                } else {
                    finalAddress = city
                }



                // update hidden fields
                $("#userCurrentCity").html(city);
                // change the user messages and reflow the data
                finalString = "Your location has been manually set as: <b>" + finalAddress + "</b>.";
                $("#user-location-message").html(finalString);

                const storedLocVars =
                    {
                        finalString: finalString,
                        user_set_lng: customLng,
                        user_set_lat: customLat
                    }

                localStorage.setItem('storedLocVars', JSON.stringify(storedLocVars));

                setCookie('userLocation_Lat', customLat, 1 );
                setCookie('userLocation_Lng', customLng, 1 );
                setCookie('userLocation_City', city, 1 );
                setCookie('userLocation_Area', address.state, 1 );
                setCookie('userLocation_Postcode', address.postcode, 1 );
            }

            else
            {
                finalString = "This location cannot be found. Please try again."
            }
            $('#location-input-info').html(finalString);
            $selectCustomLocation.removeClass("disabled");
        }


        osmSearchTownPostcode( useAddress, callback, requirements);

    }

    if ( $('#solicitor_finder_form_new').length )
    {
        monitorSolicitorFinderForm();
    }

    $("#removeSortFilters").on("click tap touchstart",  () => {
        setTimeout(() => {
            document.dispatchEvent(new Event('refresh-open-street-map'));
        }, 1)
    })

});